export function enumToOptions<T extends Record<string, string>>(enumObj: T) {
  return Object.entries(enumObj).map(([key, value]) => ({
    label: key,
    value
  }))
}

export function formatNumber(value: number): string {
  if(!value) return '';
  return new Intl.NumberFormat('sv-SE').format(value);
}

/** Formats seconds as h:mm:ss. */
export function formatDuration(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}